module.exports = __webpack_public_path__ + "img/羊耳朵.719f97f2.png";